var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["help/templates/privacy/opt-out.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var t_1;
t_1 = (lineno = 0, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.featureConfigs.ca-privacy-config",[]]));
frame.set("privacyConfig", t_1, true);
if(frame.topLevel) {
context.setVariable("privacyConfig", t_1);
}
if(frame.topLevel) {
context.addExport("privacyConfig", t_1);
}
output += "\n";
var t_2;
t_2 = (lineno = 1, colno = 27, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.privacyRestriction.userHasOptedOut",runtime.contextOrFrameLookup(context, frame, "False")]));
frame.set("userHasOptedOut", t_2, true);
if(frame.topLevel) {
context.setVariable("userHasOptedOut", t_2);
}
if(frame.topLevel) {
context.addExport("userHasOptedOut", t_2);
}
output += "\n\n\n<div class=\"o-row c-privacy-opt-out dom-privacy-opt-out\">\n\n    <div class=\"o-row o-column o-extra-small--12 s-cms\">\n        ";
output += runtime.suppressValue(env.getFilter("markdown").call(context, (lineno = 7, colno = 13, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["privacyConfig.legalCopyPrimary",""]))), env.opts.autoescape);
output += "\n    </div>\n\n    <div class=\"o-row o-column o-extra-small--12 c-privacy-opt-out__field\">\n        <p class=\"c-privacy-opt-out__label\">\n            ";
output += runtime.suppressValue((lineno = 12, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["privacyConfig.optOutLabel",""])), env.opts.autoescape);
output += "\n        </p>\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "userHasOptedOut")) {
output += "\n            <p class=\"c-privacy-opt-out__message--success\">\n                ";
if((lineno = 17, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["core.loggedIn"]))) {
output += "\n                    ";
output += runtime.suppressValue((lineno = 18, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["privacyConfig.optOutSuccessAuth",""])), env.opts.autoescape);
output += "\n                ";
;
}
else {
output += "\n                    ";
output += runtime.suppressValue((lineno = 20, colno = 25, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["privacyConfig.optOutSuccessGuest",""])), env.opts.autoescape);
output += "\n                ";
;
}
output += "\n            </p>\n        ";
;
}
output += "\n    </div>\n\n    <div class=\"o-row o-column o-extra-small--6 o-extra-large--4\">\n\n        <button class=\"c-privacy-opt-out__button ";
output += runtime.suppressValue((runtime.contextOrFrameLookup(context, frame, "userHasOptedOut")?"is-disabled":""), env.opts.autoescape);
output += " js-privacy-opt-out\">\n            ";
output += runtime.suppressValue((lineno = 29, colno = 17, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["privacyConfig.optOutButtonMessage",""])), env.opts.autoescape);
output += "\n        </button>\n\n    </div>\n\n    <div class=\"o-row o-column o-extra-small--12 s-cms\">\n        ";
output += runtime.suppressValue(env.getFilter("markdown").call(context, (lineno = 35, colno = 13, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_get"), "_get", context, ["privacyConfig.legalCopySecondary",""]))), env.opts.autoescape);
output += "\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["help/templates/privacy/opt-out.j2"] , dependencies)